import * as Hooks from 'preact/hooks';
import * as Navigation from '../../../store/actions/navigation';
import { useDispatch } from '../../hooks/redux';
import { Bundling } from '../../../data/bundling';

export const useTrackingForLoadingComplete = (sceneLoading: boolean, bundling: Bundling) => {
    const dispatch = useDispatch();
    Hooks.useEffect(() => {
        if (!sceneLoading) {
            dispatch(Navigation.initialLoadingFinishedAction({ bundling }));
        }
    }, [sceneLoading]);
};
